// extracted by css-extract-rspack-plugin
export default {"hist":"NotePreview_hist__7xT7g"};